import React, { forwardRef, ReactNode } from 'react';
import {
  Radio as ChakraRadio,
  RadioProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<RadioProps, `css`> {
  children: ReactNode;
  name?: string | undefined;
}

export const Radio = forwardRef<HTMLInputElement, Props>(
  ({ children, name, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Radio`);

    return (
      <ChakraRadio
        id={name}
        name={name}
        size="lg"
        colorScheme="red"
        ref={ref}
        __css={styles}
        {...props}
      >
        {children}
      </ChakraRadio>
    );
  }
);
export type { Props as RadioProps };
